import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Content, AlertController, ModalController, ActionSheetController } from 'ionic-angular';
import { DataProvider } from '../../providers/data';
import { LoadingProvider } from '../../providers/loading';
import { ImageProvider } from '../../providers/image';
import { UserProvider } from '../../providers/user';
import {TeamappProvider} from '../../providers/teamapp';
import { ImageModalPage } from '../image-modal/image-modal';
import { PhotoLibrary } from '@ionic-native/photo-library';

import { Camera } from '@ionic-native/camera';
import { Contacts } from '@ionic-native/contacts';
import { Keyboard } from '@ionic-native/keyboard';
import { Geolocation } from '@ionic-native/geolocation';
import { UserInfoPage } from '../user-info/user-info';


@Component({
  selector: 'page-message',
  templateUrl: 'message.html'
})
export class MessagePage {
  @ViewChild(Content) content: Content;
  @ViewChild('myInput') myInput: ElementRef;

  private userId: any;
  private userImg: any;
  private title: any;
  private message: any;
  private conversationId: any;
  private messages: any;
  private updateDateTime: any;
  private messagesToShow: any;
  private startIndex: any = -1;
  // Set number of messages to show.
  private numberOfMessages = 10;
  private loggedInUserId: any;
  enableUserDownloadPhoto: boolean = true;
  enableUserDownloadVideo: boolean = false;

  // MessagePage
  // This is the page where the user can chat with a friend.
  constructor(private photoLibrary: PhotoLibrary, public teamappProvider: TeamappProvider, public navCtrl: NavController, public navParams: NavParams, public dataProvider: DataProvider,
    public loadingProvider: LoadingProvider, public alertCtrl: AlertController, public imageProvider: ImageProvider, public modalCtrl: ModalController,
    public camera: Camera, public keyboard: Keyboard, public actionSheet: ActionSheetController, public contacts: Contacts, public geolocation: Geolocation, public userProvider: UserProvider){ }

  ionViewDidLoad() {
    
    this.userId = this.navParams.get('userId');
    this.loggedInUserId = this.userProvider.getUserID();
    
    // Get friend details.
    this.dataProvider.getUser(this.userId).snapshotChanges().subscribe((user) => {
      this.title = user.payload.val().name;
      this.userImg = user.payload.val().img;
    });

    // Get conversationInfo with friend.


    // Update messages' date time elapsed every minute based on Moment.js.
    var that = this;
    if (!that.updateDateTime) {
      that.updateDateTime = setInterval(function() {
        if (that.messages) {
          that.messages.forEach((message) => {
            let date = message.date;
            message.date = new Date(date);
          });
        }
      }, 60000);
    }
  }

  ionViewDidEnter(){
    this.scrollBottom();
  }

  // Load previous messages in relation to numberOfMessages.
  loadPreviousMessages() {
    var that = this;
    // Show loading.
    this.loadingProvider.show();
    setTimeout(function() {
      // Set startIndex to load more messages.
      if ((that.startIndex - that.numberOfMessages) > -1) {
        that.startIndex -= that.numberOfMessages;
      } else {
        that.startIndex = 0;
      }
      // Refresh our messages list.
      that.messages = null;
      that.messagesToShow = null;
      
      that.scrollTop();

      // Populate list again.
      that.ionViewDidLoad();
    }, 1000);
  }

  // Update messagesRead when user lefts this page.
  ionViewWillLeave() {
      this.setMessagesRead();
  }


  // Check if currentPage is active, then update user's messagesRead.
  setMessagesRead() {
      console.log("SET MESSAGES READ");
    if(this.messages && this.messages.length > 0) {

    } else {
      return -1;
    }
  }

  // Scroll to bottom of page after a short delay.
  scrollBottom() {
    
    var that = this;
    setTimeout(function() {
      that.content.scrollToBottom();
    }, 300);

    //this.setMessagesRead();

  }

  // Scroll to top of the page after a short delay.
  scrollTop() {
    var that = this;
    setTimeout(function() {
      that.content.scrollToTop();
    }, 300);
  }


  // Check if the user is the sender of the message.
  isSender(message) {
    if (message.sender == this.loggedInUserId) {
      return true;
    } else {
      return false;
    }
  }


  // Send message, if there's no conversation yet, create a new conversation.
  send(type) {
    if (this.message) {
      // User entered a text on messagebox
      if (this.conversationId) {
        let messages = JSON.parse(JSON.stringify(this.messages));
        messages.push({
          date: new Date().toString(),
          sender: this.loggedInUserId,
          type: type,
          message: this.message
        });

        // Update conversation on database.
        this.dataProvider.getConversation(this.conversationId).update({
          messages: messages
        });
        // Clear messagebox.
        this.message = '';
        this.scrollBottom();
      } else {
        console.log("else")
        // New Conversation with friend.
        var messages = [];
        messages.push({
          date: new Date().toString(),
          sender: this.loggedInUserId,
          type: type,
          message: this.message
        });
        var users = [];
        users.push(this.loggedInUserId);
        users.push(this.userId);
        // Add conversation.

        this.scrollBottom();
      }
    }
  }

  viewUser(userId) {
    this.navCtrl.push(UserInfoPage, { userId: userId });
  }


  attach(){
    let action = this.actionSheet.create({
      title:'Anhang hinzufügen',
      buttons:[{
        text: 'Kamera',
        handler: () =>{
          this.imageProvider.uploadPhotoMessage(this.conversationId, this.camera.PictureSourceType.CAMERA).then((url) => {
            this.message = url;
            this.send("image");
          });
        }
      },{
        text: 'Galerie',
        handler: ()=>{
          this.imageProvider.uploadPhotoMessage(this.conversationId, this.camera.PictureSourceType.PHOTOLIBRARY).then((url) => {
            this.message = url;
            this.send("image");
          });
        }
      },
      {
        text: 'Video',
        handler: () =>{
          this.imageProvider.uploadVideoMessage(this.conversationId).then(url=>{
            this.message = url;
            this.send("video");
          });
        }
      }
      ,{
        text: 'Standort',
        handler:()=>{
          this.geolocation.getCurrentPosition({
            timeout: 5000
          }).then(res => {
            let locationMessage = "Standort:<br> lat:"+res.coords.latitude+"<br> lng:"+res.coords.longitude;
            let mapUrl="<a href='https://www.google.com/maps/search/"+res.coords.latitude+","+res.coords.longitude+"'>Öffnen mit Maps</a>";

            let confirm = this.alertCtrl.create({
              title: 'Standort',
              message: locationMessage,
              buttons:[{
                text:'Abbrechen',
                handler: () =>{
                  console.log("canceled");
                }
              },{
                text: 'Teilen',
                handler: () =>{
                  this.message = locationMessage+"<br>"+mapUrl;
                  this.send("location");
                }
              }]
            });
            confirm.present();
          }, locationErr => {
            console.log("Location Error"+ JSON.stringify(locationErr));
          });
        }
      },{
        text: 'Kontakt',
        handler: () =>{
          this.contacts.pickContact().then( data =>{
            let name;
            if(data.displayName !== null) name = data.displayName;
            else name = data.name.givenName +" "+data.name.familyName;
            this.message = "<b>Name:</b> "+name+"<br><b>Mobile:</b> <a href='tel:"+data.phoneNumbers[0].value+"'>"+data.phoneNumbers[0].value+"</a>";
            this.send("contact");
          }, err=>{
            console.log(err);
          })
        }
      },{
        text: 'Abbrechen',
        role: 'cancel',
        handler: ()=>{
          console.log("cancelled");
        }
      }]
    });
    action.present();
  }

  messageMenu(menu: any, isother:boolean) {
      if(isother == false) {
          if(menu.type == 'text') {
              const actionSheet = this.actionSheet.create({
                  title: 'Nachricht',
                  buttons: [
                      {
                          text: 'Löschen',
                          handler: () => {
                              let key = this.getMessageKey(menu);
                              let keyShow = this.getMessageToShowKey(menu);
                              console.log("normal=>"+key);
                              console.log("show => "+keyShow);

                              if(key != -1) {
                                  let msgPayload = this.messages[key];
                                  msgPayload.type = 'deleted'
                                  this.messages[key] = msgPayload;
                                  this.messagesToShow[keyShow] = msgPayload;

                              }

                          }
                      },
                      {
                          text: 'Abbrechen',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              actionSheet.present();
          } else if(menu.type=='image') {
              const actionSheet = this.actionSheet.create({
                  title: 'Nachricht',
                  buttons: [
                      {
                          text: 'Löschen',
                          handler: () => {
                              let key = this.getMessageKey(menu);
                              let keyShow = this.getMessageToShowKey(menu);
                              console.log("normal=>"+key);
                              console.log("show => "+keyShow);

                              if(key != -1) {
                                  let msgPayload = this.messages[key];
                                  msgPayload.type = 'deleted'
                                  this.messages[key] = msgPayload;
                                  this.messagesToShow[keyShow] = msgPayload;

                              }

                          }
                      },
                      {
                          text: 'In Galerie speichern',
                          handler: () => {
                              this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                                  console.log(urlEncrypt);
                                  this.teamappProvider.http_request('action=generate_download_link&url='+urlEncrypt, 'gallery', false, true).then(data => {
                                      let download: any = data;
                                      console.log(download);
                                      this.photoLibrary.saveImage(download.download_url, 'teamapp');
                                  });
                                  /**/
                              })
                                  .catch(err => console.log('permissions weren\'t granted'));

                          }
                      },
                      {
                          text: 'Abbrechen',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              actionSheet.present();
          } else if(menu.type=='video') {
              const actionSheet = this.actionSheet.create({
                  title: 'Nachricht',
                  buttons: [
                      {
                          text: 'Löschen',
                          handler: () => {
                              let key = this.getMessageKey(menu);
                              let keyShow = this.getMessageToShowKey(menu);
                              console.log("normal=>"+key);
                              console.log("show => "+keyShow);

                              if(key != -1) {
                                  let msgPayload = this.messages[key];
                                  msgPayload.type = 'deleted'
                                  this.messages[key] = msgPayload;
                                  this.messagesToShow[keyShow] = msgPayload;

                              }

                          }
                      },
                      {
                          text: 'In Galerie speichern',
                          handler: () => {
                              this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                                  console.log(urlEncrypt);
                                  this.teamappProvider.http_request('action=generate_download_link_video&url='+urlEncrypt, 'gallery', false, true).then(data => {
                                      let download: any = data;
                                      console.log(download);
                                      this.photoLibrary.saveVideo(download.download_url, 'teamapp');
                                  });
                                  /**/
                              })
                                  .catch(err => console.log('permissions weren\'t granted'));

                          }
                      },
                      {
                          text: 'Abbrechen',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              actionSheet.present();
          }
      } else {
          if(menu.type == 'text') {

          } else if(menu.type=='image') {
              const actionSheet = this.actionSheet.create({
                  title: 'Nachricht',
                  buttons: [
                      {
                          text: 'In Galerie speichern',
                          handler: () => {
                              this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                                  console.log(urlEncrypt);
                                  this.teamappProvider.http_request('action=generate_download_link&url='+urlEncrypt, 'gallery', false, true).then(data => {
                                      let download: any = data;
                                      console.log(download);
                                      this.photoLibrary.saveImage(download.download_url, 'teamapp');
                                  });
                                  /**/
                              })
                                  .catch(err => console.log('permissions weren\'t granted'));

                          }
                      },
                      {
                          text: 'Abbrechen',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              actionSheet.present();
          } else if(menu.type=='video') {
              const actionSheet = this.actionSheet.create({
                  title: 'Nachricht',
                  buttons: [
                      {
                          text: 'In Galerie speichern',
                          handler: () => {
                              this.photoLibrary.requestAuthorization({read:true,write:true}).then(() => {
                                  let urlEncrypt = btoa(unescape(encodeURIComponent(menu.message)));
                                  console.log(urlEncrypt);
                                  this.teamappProvider.http_request('action=generate_download_link_video&url='+urlEncrypt, 'gallery', false, true).then(data => {
                                      let download: any = data;
                                      console.log(download);
                                      this.photoLibrary.saveVideo(download.download_url, 'teamapp');
                                  });
                                  /**/
                              })
                                  .catch(err => console.log('permissions weren\'t granted'));

                          }
                      },
                      {
                          text: 'Abbrechen',
                          role: 'cancel',
                          handler: () => {

                          }
                      }
                  ]
              });
              actionSheet.present();
          }
      }



  }

  getMessageKey(message:any) {
    console.log(this.messages);
    for(let i=0; i<this.messages.length;i++) {
      if(this.messages[i].message === message.message && message.date === this.messages[i].date) {
        return i;
      }
    }
    return -1;
  }


  getMessageToShowKey(message:any) {
      for(let i=0; i<this.messagesToShow.length;i++) {
          if(this.messagesToShow[i].message === message.message && message.date === this.messagesToShow[i].date) {
              return i;
          }
      }
      return -1;
  }

  // Enlarge image messages.
  enlargeImage(img) {
    let imageModal = this.modalCtrl.create(ImageModalPage, { img: img });
    imageModal.present();
  }

    resize() {
    var element = this.myInput['_elementRef'].nativeElement.getElementsByClassName("text-input")[0];
    var scrollHeight = element.scrollHeight;
    element.style.height = scrollHeight + 'px';
    this.myInput['_elementRef'].nativeElement.style.height = (scrollHeight + 20) + 'px';
    }
}



// WEBPACK FOOTER //
// ./src/pages/message/message.ts